const translations = {
  es: {
    // Login
    'login.title': 'TimeCards',
    'login.subtitle': 'Sistema para el calculo de horas productivas de empleados.',
    'login.stat1': 'Calculo automatico de horas',
    'login.stat2': 'Reportes listos al instante',
    'login.stat3': 'Control de horas extras y ausencias',
    'login.heading': 'Iniciar Sesion',
    'login.subheading': 'Ingresa tus credenciales para acceder al sistema.',
    'login.username': 'Usuario',
    'login.usernamePlaceholder': 'Ingresa tu usuario',
    'login.password': 'Contrasena',
    'login.passwordPlaceholder': 'Ingresa tu contrasena',
    'login.verifying': 'Verificando...',
    'login.submit': 'Ingresar al Sistema',
    'login.failed': 'Inicio de sesion fallido. Verifica tus credenciales.',
    'login.pwdExpired': 'Contrasena vencida',
    'login.pwdExpiredMsg': 'Tu contrasena tiene mas de 60 dias. Solicita tu nueva contrasena al desarrollador: jgarcia@tms-lp.com',
    'login.emptyFields': 'Campos vacios',
    'login.emptyFieldsMsg': 'Por favor ingresa tu usuario y contrasena.',
    'login.welcome': 'Bienvenido',
    'login.welcomeMsg': 'Has iniciado sesion correctamente.',
    'login.version': 'TMS Payroll v1.0',

    // Layout / Nav
    'nav.dashboard': 'Dashboard',
    'nav.employees': 'Empleados',
    'nav.absences': 'Ausencias',
    'nav.reports': 'Reportes',
    'nav.records': 'Historial',
    'nav.generate': 'Generar Reportes',
    'nav.dailyHours': 'Resumen diario',
    'daily.title': 'Resumen diario de horas — MIA',
    'daily.in': 'Entrada',
    'daily.out': 'Salida',
    'daily.gross': 'Salida − Entrada',
    'daily.total': 'Total − 30 min comida',
    'daily.noOut': 'Sin salida',
    'daily.noIn': 'Sin entrada',
    'daily.notRegistered': 'No registrado en Empleados',
    'daily.incompleteTip': 'El dia tiene una sola punta: revisa y corrige el punch en Punches.',
    'daily.legend': 'Todos los empleados de MIA que marcaron ese dia, calculado directo de los punches. "Salida − Entrada" es el tiempo de reloj; el total ya trae descontados los 30 min de comida.',
    'daily.empty': 'Nadie de MIA marco ese dia.',
    'daily.employees': 'empleados',
    'daily.grandTotal': 'Total del dia',
    'daily.downloadExcel': 'Descargar Excel',
    'daily.downloadPdf': 'Descargar PDF',
    'daily.date': 'Fecha',
    'daily.multiDayTitle': 'El archivo trae varios dias',
    'daily.multiDayMsg': '¿Quieres un solo reporte con todos los dias, o verlos separados por dia?',
    'daily.combineYes': 'Un solo reporte',
    'daily.combineNo': 'Separado por dia',
    'daily.fetchError': 'Error al cargar el resumen diario.',
    'daily.exportError': 'Error al descargar el Excel del resumen diario.',
    'daily.modeDate': 'Por fecha (base)',
    'daily.modeFile': 'Desde archivo',
    'daily.loadFile': 'Cargar archivo',
    'daily.changeFile': 'Cambiar archivo',
    'daily.pickFile': 'Carga el reporte de accesos de MIA (MIA Access Daily Report) para ver el resumen. El archivo no se guarda en la base.',
    'daily.fileEmpty': 'El archivo no trae ningun punch con fecha y hora validas.',
    'nav.timestamps': 'Punches',
    'nav.earlyAuth': 'Llegadas tempranas',
    'nav.ptoManual': 'PTO Manual',
    'nav.holidays': 'Dias Festivos',
    'pto.title': 'PTO Manual',
    'pto.help': 'Registra horas de PTO manualmente para completar el día de un empleado (ej. llegar a 40 horas) en emergencias o cuando hay que esperar un punch. Se guarda como una ausencia PTO aprobada y se suma automáticamente al calcular la semana. Un registro puede cubrir varios días seguidos: elige desde y hasta, y las horas se aplican a cada día del rango.',
    'pto.empty': 'No se encontraron registros de PTO.',
    'pto.fetchError': 'Error al cargar PTO.',
    'pto.dateCol': 'Fecha',
    'pto.dateFrom': 'Desde',
    'pto.dateTo': 'Hasta',
    'pto.days': 'dias',
    'pto.dayShort': 'dia',
    'pto.hoursCol': 'Horas PTO',
    'pto.hoursPerDay': 'Horas PTO por dia',
    'pto.rangeHint': 'Deja "Hasta" vacio para un solo dia. Si pones un rango, las horas se aplican a CADA dia del rango — incluidos sabados y domingos si quedan dentro.',
    'pto.rangeInvalid': 'La fecha final no puede ser anterior a la inicial.',
    'pto.dateReq': 'La fecha es obligatoria.',
    'pto.hoursReq': 'Las horas de PTO son obligatorias.',
    'pto.newTitle': 'Nuevo PTO',
    'pto.editTitle': 'Editar PTO',
    'pto.created': 'PTO creado.',
    'pto.updated': 'PTO actualizado.',
    'pto.deleted': 'PTO eliminado.',
    'pto.deleteConfirm': '¿Eliminar PTO?',
    'pto.notePh': 'ej. emergencia, completar a 40',
    'nav.doors': 'Puertas',
    'nav.auditLog': 'Audit Log',
    'nav.logout': 'Cerrar Sesion',
    'nav.logoutConfirm': '¿Estás seguro que deseas cerrar sesión?',
    'nav.logoutYes': 'Sí, salir',
    'nav.title': 'TMS Payroll',
    'nav.sepTime': 'Tiempo y Asistencia',
    'nav.sepConfig': 'Historial',

    // Audit Log
    'audit.title': 'Audit Log',
    'audit.empty': 'No hay registros de auditoria.',
    'audit.table': 'Tabla',
    'audit.user': 'Usuario',
    'audit.action': 'Accion',
    'audit.recordId': 'ID Registro',
    'audit.date': 'Fecha',
    'audit.ip': 'IP',
    'audit.reason': 'Razon',
    'audit.searchPh': 'Buscar en valores o razon...',
    'audit.allTables': 'Todas las tablas',
    'audit.allUsers': 'Todos los usuarios',
    'audit.allActions': 'Todas las acciones',
    'audit.before': 'Antes',
    'audit.after': 'Despues',
    'audit.viewDetail': 'Ver detalle',
    'audit.entries': 'registros',
    'audit.field': 'Campo',
    'audit.oldValue': 'Valor anterior',
    'audit.newValue': 'Valor nuevo',
    'audit.noChanges': 'Sin cambios detectados.',
    'audit.detailTitle': 'Detalle del cambio',
    'audit.reasonRequired': 'Razon requerida',
    'audit.reasonRequiredMsg': 'Indica el motivo del cambio para auditoria.',
    'audit.reasonPh': 'Por que se esta modificando?',

    // Dashboard
    'dash.title': 'Dashboard',
    'dash.employees': '1. Empleados',
    'dash.employeesDesc': 'Registrar y gestionar empleados',
    'dash.reports': '2. Reportes',
    'dash.reportsDesc': 'Importar archivo y calcular horas',
    'dash.records': '3. Historial',
    'dash.recordsDesc': 'Historial de timecards',
    'dash.absences': '4. Ausencias',
    'dash.absencesDesc': 'Registrar ausencias',
    'dash.holidays': 'Dias Festivos',
    'dash.holidaysDesc': 'Dias festivos',

    // Common
    'common.save': 'Guardar',
    'common.saving': 'Guardando...',
    'common.cancel': 'Cancelar',
    'common.close': 'Cerrar',
    'common.refresh': 'Limpiar filtros',
    'common.edit': 'Editar',
    'common.delete': 'Eliminar',
    'common.search': 'Buscar...',
    'common.select': 'Seleccionar...',
    'common.error': 'Error',
    'common.confirm': 'Confirmar',
    'common.confirmMsg': 'Esta accion no se puede deshacer.',
    'common.loading': 'Cargando...',
    'common.loadingData': 'Cargando datos...',
    'common.noData': 'No hay datos disponibles.',
    'common.exporting': 'Exportando...',
    'common.exported': 'Exportado',
    'common.importing': 'Importando...',
    'common.importExcel': 'Importar Excel',
    'common.exportExcel': 'Exportar Excel',
    'common.name': 'Nombre',
    'common.lastName': 'Apellido',
    'common.badge': 'Badge',
    'common.type': 'Tipo',
    'common.status': 'Status',
    'common.department': 'Departamento',
    'common.company': 'Compania',
    'common.location': 'Ubicacion',
    'common.actions': 'Acciones',
    'common.from': 'Desde',
    'common.to': 'Hasta',
    'common.previous': 'Anterior',
    'common.next': 'Siguiente',
    'common.showing': 'Mostrando',
    'common.of': 'de',
    'common.emptyFile': 'Archivo vacio',
    'common.emptyFileMsg': 'El archivo no contiene datos.',
    'common.fileReadError': 'No se pudo leer el archivo.',
    'common.saveError': 'Error al guardar.',
    'common.deleteError': 'Error al eliminar.',
    'common.new': 'Nuevo',
    'common.newFem': 'Nueva',
    'common.newMasc': 'Nuevo',
    'common.saved': 'Guardado',
    'common.deleted': 'Eliminado',
    'common.date': 'Fecha',
    'common.time': 'Hora',
    'common.apply': 'Aplicar',
    'common.clear': 'Limpiar',
    'common.all': 'Todos',
    'common.active': 'Activo',

    // Employees
    'emp.title': 'Empleados',
    'emp.search': 'Buscar empleado...',
    'emp.detectDups': 'Detectar duplicados',
    'emp.editTitle': 'Editar Empleado',
    'emp.newTitle': 'Nuevo Empleado',
    'emp.nameReq': 'Nombre *',
    'emp.lastNameReq': 'Apellido *',
    'emp.badgeNumber': 'Badge Number',
    'emp.shiftStart': 'Hora Entrada',
    'emp.shiftEnd': 'Hora Salida',
    'emp.schedule': 'Horario',
    'emp.updated': 'Empleado actualizado',
    'emp.created': 'Empleado creado',
    'emp.deleted': 'Empleado eliminado',
    'emp.empty': 'No se encontraron empleados.',
    'emp.deleteConfirm': 'Se eliminara este empleado permanentemente.',
    'emp.importTitle': 'Importar empleados',
    'emp.importReview': 'Revisa los datos antes de importar. Badge, Nombre y Tipo son obligatorios.',
    'emp.typeReq': 'Tipo *',
    'emp.entry': 'Entrada',
    'emp.exit': 'Salida',
    'emp.incomplete': 'Datos incompletos',
    'emp.incompleteMsg': 'Badge, Nombre, Tipo y Ubicacion son requeridos para todos los empleados.',
    'emp.imported': 'Empleados importados',
    'emp.importedMsg': 'empleados creados correctamente.',
    'emp.importError': 'Error al importar empleados.',
    'emp.searchingDups': 'Buscando duplicados...',
    'emp.noDups': 'Sin duplicados',
    'emp.noDupsMsg': 'No se encontraron empleados con nombres similares.',
    'emp.dupBadgeTitle': 'Badge duplicado',
    'emp.dupBadgeMsg': 'Ya existe un empleado con el badge {{badge}}. Revisa el archivo e intenta de nuevo.',
    'emp.dupTitle': 'Empleados duplicados',
    'emp.dupDesc': 'Empleados con nombres similares pero diferente badge. Selecciona el badge a mantener y el nombre correcto, luego fusiona.',
    'emp.dupResolved': 'Todos los duplicados han sido resueltos.',
    'emp.badgeKeep': 'Badge a mantener (User No):',
    'emp.correctName': 'Nombre correcto:',
    'emp.keep': 'MANTENER',
    'emp.remove': 'ELIMINAR',
    'emp.confirmMerge': 'Confirmar fusion',
    'emp.keepBadge': 'Mantener Badge',
    'emp.removeBadge': 'Eliminar Badge',
    'emp.finalName': 'Nombre final:',
    'emp.mergeWarning': 'Todos los timestamps, timecards y ausencias se reasignaran.',
    'emp.merge': 'Fusionar',
    'emp.merging': 'Fusionando...',
    'emp.merged': 'Fusionado',
    'emp.mergeError': 'Error al fusionar.',
    'emp.exportSuccess': 'Empleados descargados correctamente.',
    'emp.exportError': 'No se pudo exportar.',

    // Absences
    'abs.title': 'Ausencias',
    'abs.search': 'Buscar empleado...',
    'abs.editTitle': 'Editar Ausencia',
    'abs.newTitle': 'Nueva Ausencia',
    'abs.employee': 'Empleado *',
    'abs.employeeSearch': 'Buscar por nombre o badge...',
    'abs.notFound': 'Empleado no encontrado',
    'abs.startDate': 'Fecha Inicio *',
    'abs.endDate': 'Fecha Fin',
    'abs.typeReq': 'Tipo *',
    'abs.ptoHrs': 'PTO (hrs)',
    'abs.paid': 'Pagos',
    'abs.unpaid': 'Sin Pago',
    'abs.updated': 'Ausencia actualizada',
    'abs.created': 'Ausencia registrada',
    'abs.deleted': 'Ausencia eliminada',
    'abs.empty': 'No se encontraron ausencias.',
    'abs.deleteConfirm': 'Se eliminara esta ausencia permanentemente.',
    'abs.importTitle': 'Importar Ausencias',
    'abs.importFound': 'Se detectaron',
    'abs.importRecords': 'registros listos para importar.',
    'abs.importCols': 'Verifica que los datos sean correctos antes de continuar.',
    'abs.importMore': 'registros adicionales no mostrados',
    'abs.importComplete': 'Importacion completa',
    'abs.importedMsg': 'ausencias importadas.',
    'abs.importSkipped': 'omitidos porque el empleado no existe. Registra los badges antes de importar:',
    'abs.importError': 'Error al importar.',
    'abs.tabAbsences': 'Ausencias en sistema',
    'abs.tabRequests': 'Solicitudes aprobadas',
    'abs.pendingBubble': 'Solicitudes aprobadas por agregar al sistema',
    'absReq.fetchError': 'Error al cargar las solicitudes aprobadas.',
    'absReq.requester': 'Solicitante',
    'absReq.weekdays': 'Dias habiles',
    'absReq.weekdaysLower': 'dias habiles',
    'absReq.approvedBy': 'Aprobo',
    'absReq.employee': 'Empleado en sistema',
    'absReq.unlinked': 'Sin ligar',
    'absReq.inSystem': 'En sistema',
    'absReq.pending': 'Por agregar',
    'absReq.apply': 'Agregar',
    'absReq.applied': 'Solicitud agregada al sistema',
    'absReq.applyTitle': 'Agregar solicitud al sistema',
    'absReq.day': 'dia',
    'absReq.search': 'Buscar por nombre o email...',
    'absReq.allTypes': 'Todos los tipos',
    'absReq.onlyPending': 'Solo por agregar',
    'absReq.empty': 'No hay solicitudes aprobadas.',
    'absReq.managerComment': 'Comentario del manager',
    'absReq.byName': '(sugerido por nombre, confirma que sea la persona)',
    'absReq.changeEmployee': 'Cambiar empleado...',
    'absReq.newEmp': 'No esta dado de alta? Registrarlo',
    'absReq.newEmpTitle': 'Registrar empleado nuevo',
    'absReq.newEmpSave': 'Registrar empleado',
    'absReq.newEmpMissing': 'Faltan datos',
    'absReq.newEmpMissingMsg': 'Badge, nombre, apellido, ubicacion y tipo son obligatorios.',
    'absReq.newEmpNotPerm': 'Ojo: solo los PERM cobran PTO. Con este tipo la ausencia queda registrada pero en 0 h.',
    'absReq.summary': 'Se agregan {days} dias habiles (sabado y domingo no cuentan) = {hrs} h de PTO.',
    'abs.invalidEmp': 'Empleado no valido',
    'abs.invalidEmpMsg': 'Ingresa un badge valido y espera la verificacion.',
    'abs.invalidDates': 'Fechas invalidas',
    'abs.invalidDatesMsg': 'La fecha fin no puede ser menor a la fecha inicio.',
    'abs.fileError': 'No se pudo leer el archivo Excel.',
    'abs.dept': 'Depto',
    'abs.employee2': 'Empleado',
    'abs.startDateCol': 'Fecha Inicio',
    'abs.endDateCol': 'Fecha Fin',

    // Reports
    'rep.title': 'Reportes',
    'rep.selectFacility': 'Seleccionar Facilidad',
    'rep.miami': 'Miami',
    'rep.austin': 'Austin',
    'rep.importFile': 'Importar Archivo',
    'rep.clickUpload': 'Click para seleccionar archivo',
    'rep.changeFile': 'Cambiar archivo',
    'rep.selectFirst': 'Selecciona facilidad primero',
    'rep.xlsFormat': '.xlsx o .xls',
    'rep.records': 'registros de',
    'rep.processing': 'Procesando...',
    'rep.import': 'Importar',
    'rep.importRecords': 'registros',
    'rep.saving': 'Guardando...',
    'rep.savingMsg': 'Importando timestamps y calculando horas.',
    'rep.calculating': 'Calculando horas por empleado...',
    'rep.importComplete': 'Importacion completa',
    'rep.noDateTitle': 'Sin fechas',
    'rep.noDateMsg': 'No se detectaron fechas en el archivo.',
    'rep.processError': 'Error al procesar',
    'rep.unexpectedError': 'Error inesperado.',
    'rep.recalculating': 'Recalculando...',
    'rep.recalcComplete': 'Recalculacion completa',
    'rep.recalcMsg': 'timecards calculados.',
    'rep.period': 'Periodo:',
    'rep.recalcError': 'Error al recalcular.',
    'rep.typeRequired': 'Tipo requerido',
    'rep.typeRequiredMsg': 'Selecciona el tipo para todas las puertas.',
    'rep.configureDoors': 'Configurar puertas',
    'rep.configureDoorsDesc': 'Las siguientes puertas del archivo no estan configuradas. Asigna el tipo de cada una.',
    'rep.doorName': 'Nombre de puerta',
    'rep.configAndContinue': 'Configurar y continuar',
    'rep.configError': 'Error al configurar puertas.',
    'rep.fileDups': 'Posibles duplicados en archivo',
    'rep.fileDupsDesc': 'El archivo contiene badges con nombres similares. Selecciona el badge a mantener y el nombre correcto.',
    'rep.samePerson': 'Son la misma persona',
    'rep.detectedBadges': 'Badges detectados:',
    'rep.inSystem': 'EN SISTEMA',
    'rep.mergeLabel': 'FUSIONAR',
    'rep.mergeTimestamps': 'Los timestamps del badge fusionado se reasignaran al badge mantenido.',
    'rep.separateImport': 'Se importaran como empleados separados.',
    'rep.continue': 'Continuar',
    'rep.missingTitle': 'Empleados no registrados',
    'rep.missingDesc': 'Los siguientes empleados aparecen en el archivo pero no estan registrados. Completa su informacion para continuar con la importacion.',
    'rep.mismatchTitle': 'Gafetes a nombre de otra persona',
    'rep.mismatchDesc': 'El badge SI esta dado de alta, pero el archivo lo trae a nombre de alguien distinto. Si no se decide nada, las horas de quien trae ese gafete se le pagan al empleado registrado. El nombre solo viene en el archivo, asi que este es el unico momento en que se puede notar.',
    'rep.mismatchFile': 'En el archivo:',
    'rep.mismatchRegistered': 'Registrado como:',
    'rep.mismatchExisting': 'Ya esta dada de alta:',
    'rep.mismatchRemapHint': 'Sus punches de este archivo se le reasignan a ese badge, que es donde estan sus horas. No se da de alta a nadie: esta persona ya existe.',
    'rep.mismatchIgnore': 'Dejarlo asi (es la misma persona)',
    'rep.mismatchRegister': 'Es otra persona: darla de alta aparte',
    'rep.mismatchRegisterHint': 'El badge del archivo ya esta ocupado por el empleado registrado, asi que hay que asignarle uno nuevo. Los punches de ESTE archivo se le reasignan al badge nuevo, para que sus horas salgan en el calculo a su nombre y no a nombre del otro. Los punches de importaciones anteriores se quedan donde estan.',
    'rep.mismatchNewBadge': 'Badge nuevo *',
    'rep.newBadgeRequired': 'Falta el badge nuevo',
    'rep.newBadgeRequiredMsg': 'Asignale un badge a cada persona que se va a dar de alta aparte.',
    'rep.sameAs': 'Es el mismo que',
    'rep.timestampsAssign': 'Los timestamps de Badge',
    'rep.willAssignTo': 'se asignaran a Badge',
    'rep.sameBadgeIntro': 'Este gafete ya esta dado de alta, con el mismo numero, en otra planta:',
    'rep.sameBadgeCopy': 'Darlo de alta TAMBIEN en {fac}, con los mismos datos',
    'rep.sameBadgeMove': 'Moverlo de {from} a {to} (se transfirio de planta)',
    'rep.sameBadgeNew': 'Es otra persona: darlo de alta desde cero',
    'rep.sameBadgeCopyHint': 'Queda con una ficha en cada planta y cada una le calcula y paga su propia semana. Los datos (nombre, tipo, depto, compañia y turno) se copian de la ficha que ya existe.',
    'rep.sameBadgeMoveHint': 'Su ficha cambia de planta; no se duplica. Las semanas ya calculadas en la planta anterior se quedan como estan.',
    'rep.sameBadgeNewHint': 'Se crea una ficha nueva con los datos que captures abajo. Usalo solo si de verdad es otra persona con el mismo numero de gafete.',
    'rep.saveAndContinue': 'Guardar y continuar',
    'rep.createError': 'Error al crear empleados.',
    'rep.generateReports': 'Generar Reportes',
    'rep.generateTimecards': 'Generar Timecards',
    'rep.generatePayrolls': 'Generar Payroll',
    'rep.recalculate': 'Recalcular',
    'rep.needWeekFacility': 'Elige una semana y una instalacion',
    'rep.needWeekFacilityWhy': 'El recalculo va acotado: filtra una semana completa de lunes a domingo y una instalacion. Despues podras elegir a que empleados de esa semana recalcular.',
    'rep.recalcTip': 'Vuelve a calcular esta semana. Primero se abre Horas de entrada del periodo, donde eliges a que empleados incluir y decides sus horas y sus lunch.',
    'rep.selectFacilityTitle': 'Selecciona facilidad',
    'rep.selectFacilityMsg': 'Selecciona Miami o Austin antes de importar.',
    'rep.fileLoaded': 'Archivo cargado',
    'rep.fileLoadedMsg': 'registros listos para importar.',
    'rep.fileReady': 'Archivo listo',
    'rep.fileReadyMsg': 'registros listos para importar. Duplicados resueltos.',
    'rep.noHours': 'No se calcularon horas para el periodo',
    'rep.checkDoors': 'Verifica las puertas configuradas.',
    'rep.employees': 'empleados',
    'rep.exportError': 'Error al exportar',
    'rep.exportErrorMsg': 'No se pudo generar el archivo.',
    'rep.downloadSuccess': 'descargado correctamente.',

    // Days
    'day.mon': 'Lun',
    'day.tue': 'Mar',
    'day.wed': 'Mie',
    'day.thu': 'Jue',
    'day.fri': 'Vie',
    'day.sat': 'Sab',
    'day.sun': 'Dom',

    // Hours
    'hrs.total': 'Total',
    'hrs.regular': 'Regular',
    'hrs.overtime': 'Horas Extra',
    'hrs.paidAbs': 'Ausencia Pagada',
    'hrs.facility': 'Facilidad',
    'hrs.employee': 'Empleado',

    // Records
    'rec.title': 'Historial de Horas',
    'gen.title': 'Generar Reportes',
    'gen.pick': 'Que quieres generar',
    'gen.intro': 'Elige el documento y en la ventana siguiente defines el periodo, la facilidad y a quien cubre. Antes de descargar vas a revisar con que hora se paga cada dia.',
    'gen.how': 'Como funciona',
    'gen.step1': 'Defines el alcance',
    'gen.step1Desc': 'Periodo, facilidad y si el reporte cubre a todos, a un tipo de empleado o a una sola persona.',
    'gen.step2': 'Revisas las horas',
    'gen.step2Desc': 'Se listan los dias con punches del periodo para confirmar o corregir la entrada, la salida y la comida de cada uno.',
    'gen.step3': 'Se recalcula y se descarga',
    'gen.step3Desc': 'El periodo se recalcula con lo que confirmaste y el archivo sale de eso, asi que lo que baja es lo que acabas de revisar.',
    'rec.search': 'Buscar por badge o nombre...',
    'rec.empty': 'No se encontraron timecards.',
    'rec.datesRequired': 'Fechas requeridas',
    'rec.datesRequiredMsg': 'Selecciona un rango de fechas para exportar.',
    'rec.weekRangeRequired': 'Rango semanal requerido',
    'rec.weekRangeRequiredMsg': 'El rango debe cubrir exactamente una semana de lunes a domingo (igual que Reports).',
    'rec.facilityRequired': 'Facility requerida',
    'rec.facilityRequiredMsg': 'Selecciona una facility (MIA o AUSWH) antes de continuar.',
    'rec.tcDownloaded': 'Timecards descargado correctamente.',
    'rec.prDownloaded': 'Payroll descargado correctamente.',
    'rec.exportError': 'No se pudo exportar.',
    'rec.period': 'Periodo',
    'rec.door': 'Puerta',
    'rec.action': 'Accion',
    'rec.lateDays': 'Tardes',
    'rec.lateDaysTooltip': 'Dias con retardo COBRADO (>= 60 min despues del inicio de turno). Los perdonados y los autorizados no cuentan.',
    'rec.missingOutTooltip': 'Falta salida (clock-out) — calculado por ley, revisar',
    // Hora de entrada pagada (tooltip de cada dia)
    'rec.paidIn': 'Entrada pagada',
    'rec.paidOut': 'Salida pagada',
    'rec.firstPunch': 'Punch real',
    'rec.punchOut': 'Punch de salida',
    'rec.shiftStartShort': 'Inicio de turno',
    'rec.lateBy': 'retardo cobrado',
    'rec.lunchOn': 'Lunch: se descontaron 30 min',
    'rec.lunchOff': 'Lunch: no se descuenta',
    'rec.lunchNone': 'Sin lunch',
    'rec.lunchForced': 'decidido a mano',
    'rec.noOut': 'Sin salida: pagado con las horas por ley',
    'rec.outNotStored': 'Recalcula la semana para guardar la hora de salida de este dia.',
    'rec.inWhy.edited': 'hora capturada en el modal de calculo',
    'rec.inWhy.auth': 'autorizacion aplicada',
    'rec.inWhy.forgiven': 'retardo perdonado (se paga desde el inicio de turno)',
    'rec.inWhy.margin': 'tardanza dentro del margen de 30 min (perdonada por el esquema anterior)',
    'rec.inWhy.rounded': 'entrada temprana redondeada al inicio de turno (esquema anterior)',
    'rec.inWhy.actualEarly': 'entrada temprana pagada con la hora real',
    'rec.inWhy.actualLate': 'entrada tarde pagada con la hora real',
    'rec.inWhy.charged': 'retardo cobrado con la hora real',
    'rec.inWhy.exact': 'entrada a tiempo',
    'rec.inNotStored': 'Recalcula la semana para guardar la hora de entrada de este dia.',
    'rec.inLegend': 'Debajo de las horas de cada dia: la hora de entrada con la que se pago. Por defecto es la hora real del punch (ya no se redondea nada). En verde y con • solo los dias donde alguien decidio otra hora: capturada en el modal de calculo, o venida de una autorizacion. Pasa el mouse para ver el detalle.',

    // Early arrival authorizations
    'ea.title': 'Llegadas tempranas autorizadas',
    'ea.help': 'Cuando un empleado tiene autorización para llegar temprano en una fecha, se aplica automáticamente al calcular la semana (sin preguntar). Si indicas una hora autorizada, esa hora se usa como su entrada (clock-in); si la dejas vacía, se conserva su hora real fichada.',
    'ea.empty': 'No se encontraron autorizaciones.',
    'ea.fetchError': 'Error al cargar autorizaciones.',
    'ea.dateCol': 'Fecha',
    'ea.timeCol': 'Hora autorizada',
    'ea.ptoCol': 'PTO (hrs)',
    'ea.ptoPh': 'ej. 8',
    'ea.shiftCol': 'Hora de turno',
    'ea.note': 'Nota',
    'ea.notePh': 'ej. avisó por chat',
    'ea.dateReq': 'La fecha es obligatoria.',
    'ea.newTitle': 'Nueva autorización',
    'ea.editTitle': 'Editar autorización',
    'ea.created': 'Autorización creada.',
    'ea.updated': 'Autorización actualizada.',
    'ea.deleted': 'Autorización eliminada.',
    'ea.deleteConfirm': '¿Eliminar autorización?',
    'nav.lateAuth': 'Retardos autorizados',
    'la.title': 'Retardos autorizados',
    'la.help': 'Cuando un empleado tiene autorización para llegar tarde en una fecha, se oculta la alerta de retardo (amarillo/naranja) ese día. Si indicas una hora autorizada, esa hora se usa como su entrada (clock-in) al calcular; si la dejas vacía, se conserva su hora real fichada.',
    'la.empty': 'No se encontraron autorizaciones.',
    'la.fetchError': 'Error al cargar autorizaciones.',
    'la.dateCol': 'Fecha',
    'la.timeCol': 'Hora autorizada',
    'la.ptoCol': 'PTO (hrs)',
    'la.ptoPh': 'ej. 8',
    'la.shiftCol': 'Hora de turno',
    'la.note': 'Nota',
    'la.notePh': 'ej. avisó por chat',
    'la.dateReq': 'La fecha es obligatoria.',
    'la.newTitle': 'Nueva autorización',
    'la.editTitle': 'Editar autorización',
    'la.created': 'Autorización creada.',
    'la.updated': 'Autorización actualizada.',
    'la.deleted': 'Autorización eliminada.',
    'la.deleteConfirm': '¿Eliminar autorización?',

    // Holidays
    'hol.title': 'Dias Festivos',
    'hol.generate': 'Generar Dias Festivos',
    'hol.generating': 'Generando...',
    'hol.date': 'Fecha',
    'hol.origDate': 'Fecha Original',
    'hol.takenDate': 'Fecha a Considerar',
    'hol.takenDateHelp': 'Fecha que la empresa toma en cuenta para el calculo. Si se deja vacia, se usa la fecha original.',
    'hol.editTitle': 'Editar Dia Festivo',
    'hol.newTitle': 'Nuevo Dia Festivo',
    'hol.nameReq': 'Nombre *',
    'hol.dateReq': 'Fecha Original *',
    'hol.updated': 'Dia festivo actualizado',
    'hol.created': 'Dia festivo creado',
    'hol.deleted': 'Dia festivo eliminado',
    'hol.empty': 'No hay dias festivos para',
    'hol.deleteConfirm': 'Se eliminara este dia festivo permanentemente.',
    'hol.generated': 'dias festivos generados.',
    'hol.alreadyExist': 'ya existian.',
    'hol.generateError': 'Error al generar dias festivos.',

    // Doors
    'door.title': 'Puertas',
    'door.desc': 'Configura las puertas del edificio para el calculo correcto de entradas, salidas y lunch. Solo las puertas con tipo (Clock In, Clock Out, Lunch) y status Active se usan para calcular horas.',
    'door.editTitle': 'Editar Puerta',
    'door.newTitle': 'Nueva Puerta',
    'door.number': 'Numero *',
    'door.nameReq': 'Nombre *',
    'door.noType': 'Sin tipo',
    'door.facility': 'Facilidad',
    'door.priority': 'Prioridad Clock In',
    'door.priorityHint': '0 = sin prioridad, 1 = principal, 2 = secundaria...',
    'door.updated': 'Puerta actualizada',
    'door.created': 'Puerta creada',
    'door.deleted': 'Puerta eliminada',
    'door.empty': 'No hay puertas registradas.',
    'door.deleteConfirm': 'Se eliminara esta puerta permanentemente.',
    'door.clockIn': 'Clock In',
    'door.clockOut': 'Clock Out',
    'door.lunch': 'Lunch',
    'door.clockInNoCount': 'Clock In (No Count)',
    'door.lobby': 'Lobby (Sala de Espera)',

    // Punches (Timestamps)
    'ts.title': 'Punches',
    'ts.addManual': 'Agregar punch manual',
    'ts.addTitle': 'Agregar Punch Manual',
    'ts.secWho': 'Empleado',
    'ts.changeEmp': 'Cambiar de empleado',
    'ts.clearEmpFilter': 'Quitar el filtro de empleado',
    'ts.existingTitle': 'Ya hay punches en esos dias',
    'ts.existingHint': 'Si lo que quieres es arreglar uno de estos, usa "Corregir" en vez de capturar uno nuevo: corregir un punch importado hace que el archivo deje de reinsertarlo. Si capturas uno aparte, los dos conviven y el calculo se queda con el mas temprano.',
    'ts.tagImported': 'del archivo',
    'ts.tagManual': 'a mano',
    'ts.correct': 'Corregir',
    'ts.correctTip': 'Editar este punch en vez de capturar uno nuevo. Tu cambio queda protegido de las recargas del archivo.',
    'ts.switchToEditTitle': 'Cambiar a corregir?',
    'ts.switchToEditMsg': 'Se descarta lo que llevas capturado en este modal y se abre el punch existente para editarlo.',
    'ts.switchToEditYes': 'Si, corregir ese',
    'ts.punch': 'Punch',
    'ts.punches': 'punches',
    'ts.punchesLabel': 'Punches a agregar',
    'ts.linesHint': 'Puedes capturar varios punches del mismo empleado de una vez — la semana completa si hace falta. Cada renglon se guarda como un punch propio; el nuevo copia el anterior para que solo cambies lo que sea distinto. Un renglon sin hora no se guarda.',
    'ts.addLine': 'Agregar otro punch',
    'ts.removeLine': 'Quitar este punch',
    'ts.dupLine': 'Hay dos punches con la misma fecha y hora.',
    'ts.dupExisting': 'Ese punch ya existe en ese dia.',
    'ts.dupExistingWhy': 'Ya hay un punch guardado a esa misma hora. Usa "Corregir" sobre el que ya existe en vez de capturar otro igual.',
    'ts.punchesSaved': 'punches guardados',
    'ts.editTitle': 'Editar Punch',
    'ts.searchPh': 'Nombre o badge',
    'ts.showDeleted': 'Mostrar eliminados',
    'ts.entries': 'registros',
    'ts.empty': 'No hay punches.',
    'ts.deleted': 'Eliminado',
    'ts.deleteTitle': '¿Eliminar punch?',
    'ts.reasonLabel': 'Razon',
    'ts.reasonPh': '¿Por que se elimina?',
    'ts.reasonReq': 'La razon es obligatoria.',
    'ts.reasonEditPh': '¿Por que se esta editando?',
    'ts.reasonCreatePh': 'Opcional — ej. olvido checar',
    'ts.badgeReq': 'Selecciona un empleado.',
    'ts.fieldsReq': 'Llena todos los campos requeridos.',
    'ts.doorReq': 'Selecciona una puerta.',
    'ts.doorReqWhy': 'Las horas se calculan a partir de la puerta, asi que un punch sin puerta se ignora.',
    'ts.manual': 'Manual',
    'ts.manualTooltip': 'Capturado o corregido a mano: lleva una razon en la bitacora y se conserva al volver a subir el reporte.',
    'ts.onlyIncomplete': 'Solo incompletos',
    'ts.missingOut': 'Falta clock-out este dia',
    'ts.missingIn': 'Falta clock-in este dia',
    'ts.incomplete': 'Incompleto',
    'ts.onlyLate': 'Solo tardanzas',
    'ts.late': 'Tarde',
    'ts.lateTooltip': 'Llegada tardia',

    // Status options
    'status.active': 'Activo',
    'status.inactive': 'Inactivo',
    'status.terminated': 'Terminado',

    // Raw data table headers
    'raw.dateTime': 'Fecha/Hora',
    'raw.userNo': 'No. Usuario',
    'raw.userName': 'Nombre Usuario',
    'raw.doorName': 'Nombre Puerta',
    'raw.message': 'Mensaje',

    // Export filter modal
    'export.titleTimecards': 'Exportar Timecards',
    'export.titlePayroll': 'Exportar Payroll',
    'export.filterLabel': 'Filtrar empleados',
    'export.allEmployees': 'Todos los empleados',
    'export.byType': 'Por tipo de empleado',
    'export.byBadge': 'Por numero de badge',
    'export.byEmployee': 'Por empleado',
    'export.badgePlaceholder': 'Ingresa el numero de badge',
    'export.employeePlaceholder': 'Buscar por nombre o badge...',
    'export.reportType': 'Tipo de reporte',
    'export.detailed': 'Payroll detallado',
    'export.detailedSub': 'Desglose dia por dia',
    'export.summary': 'Resumen total de horas',
    'export.summarySub': 'Condensado, sin desglose diario',
    'export.allEmployeesSub': 'Toda la facilidad',
    'export.byTypeSub': 'PERM, TEMP, CONTR...',
    'export.byEmployeeSub': 'Una sola persona',
    'export.pdfSub': 'Listo para imprimir',
    'export.excelSub': 'Editable en hoja de calculo',
    'export.thisWeek': 'Esta semana',
    'export.lastWeek': 'Semana pasada',
    'export.willDownload': 'Vas a descargar',
    'export.pendingFacility': 'Falta la facilidad',
    'export.pendingDates': 'Falta el periodo',
    'export.pendingEmployee': 'Falta elegir al empleado',
    'export.facilityFromEmployee': 'Tomada del empleado',
    'export.facilityMismatch': 'Este empleado es de otra facilidad',
    'export.manualChecking': 'Revisando punches manuales...',
    'export.manualNone': 'Sin punches capturados a mano en el periodo',
    'export.manualFound': 'punches capturados a mano en el periodo',
    'export.manualWhy': 'Los captura una persona con una razon, no vienen del lector de puertas. Conviene revisarlos antes de pagar.',
    'export.manualMore': 'y {n} mas',
    'export.export': 'Exportar',
    'export.facilityLabel': 'Facilidad',
    'export.facilityRequired': 'Selecciona una facilidad',
    'export.selectFacility': 'Seleccionar facilidad...',
    'export.companyLabel': 'Compania',
    'export.allCompanies': 'Todas las companias',
    'export.sectionDocument': 'Documento',
    'export.sectionFilters': 'Filtros',
    'export.sectionPeriod': 'Periodo',
    'export.periodRequired': 'Selecciona el rango de fechas a exportar',
    'export.periodHint': 'El reporte usa estas fechas, no las del filtro de la pantalla.',
    'export.format': 'Formato de archivo',
    'export.pdf': 'PDF',
    'export.excel': 'Excel',

    // Early arrivals modal
    'early.title': 'Horas de entrada del periodo',
    'early.description': 'Cada dia se paga con la hora REAL del punch. No se redondea nada automaticamente: si un dia se debe pagar con otra hora, escribela aqui.',
    'early.dayHint': 'Se marcan en naranja las entradas tempranas (antes del turno) y los retardos (mas de 30 min despues), y en morado los dias que traen vacaciones, PTO o festivo pero aun asi tienen punches. Puedes editar cualquier dia; los que tienen hora autorizada abren con esa hora ya puesta.',
    'early.shiftStart': 'Inicio de turno:',
    'early.authorized': 'Autorizado',
    'early.day': 'dia',
    'early.days': 'dias',
    'early.employee': 'empleado',
    'early.employees': 'empleados',
    'early.editableDays': 'dias editables',
    'early.colDate': 'Fecha',
    'early.colPunch': 'Entrada real',
    'early.colPunchOut': 'Salida real',
    'early.colFlag': 'Alerta',
    'early.colPaid': 'Se paga desde',
    'early.colPaidOut': 'Se paga hasta',
    'early.colLunch': 'Lunch',
    'early.flagEarly': 'Temprana',
    'early.flagLate': 'Retardo',
    'early.flagManual': 'Capturado a mano',
    'early.flagAbsence': 'Ausencia',
    'early.flagHoliday': 'Festivo',
    'early.noPunch': 'sin punches',
    'early.noPunchTip': 'Dia de la ausencia en el que no marco: no hay hora de entrada que decidir. Se lista para que veas la ausencia completa.',
    'early.absDay': 'dia con vacaciones/ausencia',
    'early.absDays': 'dias con vacaciones/ausencia',
    'early.absTip': 'Este dia tiene una ausencia aprobada y aun asi hay punches. No paga horas de PTO (el empleado no es PERM o la ausencia va sin horas), asi que se calcula con sus punches como cualquier dia.',
    'early.absPaysTip': 'Este dia tiene una ausencia aprobada y aun asi hay punches. El dia paga lo trabajado MAS las horas de la ausencia:',
    'early.holPaysTip': 'Dia festivo sin punches: se paga la jornada completa del empleado, de su hora de entrada a su hora de salida. El festivo no descuenta comida.',
    'early.unregistered': 'No existe',
    'early.unregisteredTip': 'Este badge tiene punches pero NO esta dado de alta en Empleados con esta facilidad. El calculo le paga horas de todas formas, asi que conviene registrarlo o revisar de quien es ese badge.',
    'early.unregWarnOne': 'badge marco en el periodo y no esta dado de alta en Empleados.',
    'early.unregWarnMany': 'badges marcaron en el periodo y no estan dados de alta en Empleados.',
    'early.unregWarnDesc': 'El calculo les paga horas igual. Dalos de alta aqui mismo con el boton Registrar, o revisa de quien son esos gafetes.',
    'early.register': 'Registrar',
    'early.registerTip': 'Dar de alta este badge en Empleados sin salir del calculo.',
    'early.registerSave': 'Dar de alta',
    'early.registered': 'Registrado',
    'early.registeredTip': 'Este badge se acaba de dar de alta en Empleados.',
    'early.regNameReq': 'Nombre y apellido son requeridos.',
    'early.regTypeReq': 'El tipo es requerido.',
    'early.regError': 'No se pudo dar de alta el empleado.',
    'early.inactive': 'Inactivo',
    'early.inactiveTip': 'Este badge esta dado de alta pero con estatus distinto de Active, y aun asi marco en el periodo. El calculo le paga horas de todas formas: revisa si la baja esta bien hecha o de quien es ese gafete.',
    'early.holWorkedTip': 'Dia festivo en el que si hubo punches: el dia paga lo trabajado, el festivo no suma horas encima.',
    'early.ptoIgnored': 'trabajado + PTO',
    'early.ptoIgnoredTip': 'Dia con vacaciones/PTO aprobado y punches: el dia paga lo trabajado (menos la comida, si la casilla va marcada) MAS las horas de la ausencia. El In y el Out no se editan aqui, pero su comida si.',
    'early.punchTip': 'Hora a la que el empleado marco entrada.',
    'early.paidTip': 'Hora con la que se pagara este dia. Por defecto es el punch real.',
    'early.punchOutTip': 'Hora a la que el empleado marco salida.',
    'early.paidOutTip': 'Hora hasta la que se pagara este dia. Por defecto es el punch de salida. Si el dia no tiene salida, escribela aqui y el dia se calcula normal (salida - entrada - lunch).',
    'early.lunchTip': 'Si se descuentan los 30 min de comida en este dia. Viene marcado por defecto en toda jornada normal, sin importar cuantas horas sean. Desmarcalo si ese dia no tomo comida.',
    'early.lunchForced': 'Lunch forzado',
    'early.lunchForcedTip': 'Este dia no sigue el default: alguien decidio a mano si lleva comida o no.',
    'early.shortDay': 'Solo paga',
    'early.shortDayAsk': '¿comió?',
    'early.shortDayTip': 'Este dia de Austin paga menos que las horas por ley de la facilidad (5 h) y aun asi trae los 30 min de comida descontados. Alla no hay puerta de comedor, asi que los punches no dicen si la persona comio: si no comio, desmarca la casilla de Lunch y el dia recupera la media hora.',
    'early.noOut': 'Sin salida',
    'early.noOutTip': 'Este dia tiene entrada pero ningun punch de salida. Tal como esta se paga con las horas provisionales por ley (MIA 6:30, AUSWH 4:30). Escribe la hora de salida para que se calcule normal.',
    'early.badSpan': 'Salida antes de la entrada',
    'early.badSpanTip': 'La salida ({out}) es anterior o igual a la entrada ({in}). Casi siempre es un AM que debio ser PM: el dia entra a 0 horas y sale en blanco en el timecard exportado. Corrige la hora antes de calcular.',
    'early.badSpanDay': 'dia mal capturado',
    'early.badSpanDays': 'dias mal capturados',
    'early.badSpanCardTip': 'Este empleado tiene dias con la salida antes de la entrada. Revisa el AM/PM de las horas en rojo.',
    'early.badSpanWarnOne': 'dia con la salida antes de la entrada',
    'early.badSpanWarnMany': 'dias con la salida antes de la entrada',
    'early.badSpanWarnDesc': 'Revisa el AM/PM: una salida de las 3 de la tarde escrita como 3:00 AM queda antes de la entrada. El calculo no maneja turnos que cruzan la medianoche, asi que esos dias pagarian 0 horas y apareceran vacios en el reporte exportado. No se puede calcular hasta corregirlos.',
    'early.badSpanMore': 'y {n} mas',
    'early.badSpanBlocked': 'Corrige las horas en rojo para continuar.',
    'early.resetTip': 'Volver a las horas reales del punch.',
    'early.allPunch': 'Todo con hora real',
    'early.allShift': 'Todo desde el turno',
    'early.alertDay': 'dia con alerta',
    'early.alertDays': 'dias con alerta',
    'early.editedDay': 'dia editado',
    'early.editedDays': 'dias editados',
    'early.editedSummary': 'dias se pagaran con una hora distinta al punch',
    'early.includeTip': 'Incluir a este empleado en el calculo. Desmarcado, su semana se queda tal como esta: conserva las horas y los lunch que se le decidieron antes.',
    'early.excludedSummary': 'empleados fuera del calculo',
    'early.noneSelected': 'Marca al menos un empleado para calcular.',
    'early.defaultSummary': 'dias se pagaran con la hora real del punch',
    'early.continue': 'Continuar al calculo',
    'early.scanning': 'Buscando horas de entrada...',

    // Merge result
    'emp.mergeResult': 'Timestamps: {{timestamps}}, Timecards: {{timecards}}, Ausencias: {{absences}}',
  },

  en: {
    // Login
    'login.title': 'TimeCards',
    'login.subtitle': 'System for calculating employee productive hours.',
    'login.stat1': 'Automatic hour calculation',
    'login.stat2': 'Reports ready instantly',
    'login.stat3': 'Overtime and absence control',
    'login.heading': 'Sign In',
    'login.subheading': 'Enter your credentials to access the system.',
    'login.username': 'Username',
    'login.usernamePlaceholder': 'Enter your username',
    'login.password': 'Password',
    'login.passwordPlaceholder': 'Enter your password',
    'login.verifying': 'Verifying...',
    'login.submit': 'Sign In',
    'login.failed': 'Login failed. Check your credentials.',
    'login.pwdExpired': 'Password expired',
    'login.pwdExpiredMsg': 'Your password is more than 60 days old. Request your new password from the developer: jgarcia@tms-lp.com',
    'login.emptyFields': 'Empty fields',
    'login.emptyFieldsMsg': 'Please enter your username and password.',
    'login.welcome': 'Welcome',
    'login.welcomeMsg': 'You have signed in successfully.',
    'login.version': 'TMS Payroll v1.0',

    // Layout / Nav
    'nav.dashboard': 'Dashboard',
    'nav.employees': 'Employees',
    'nav.absences': 'Absences',
    'nav.reports': 'Reports',
    'nav.records': 'Records',
    'nav.generate': 'Generate Reports',
    'nav.dailyHours': 'Daily summary',
    'daily.title': 'Daily Hours Summary — MIA',
    'daily.in': 'In',
    'daily.out': 'Out',
    'daily.gross': 'Out − In',
    'daily.total': 'Total − 30 min lunch',
    'daily.noOut': 'No clock-out',
    'daily.noIn': 'No clock-in',
    'daily.notRegistered': 'Not in Employees',
    'daily.incompleteTip': 'The day has only one side: review and fix the punch in Punches.',
    'daily.legend': 'Every MIA employee who punched that day, computed straight from the punches. "Out − In" is the clock time; the total already has the 30-min lunch taken out.',
    'daily.empty': 'Nobody from MIA punched that day.',
    'daily.employees': 'employees',
    'daily.grandTotal': 'Day total',
    'daily.downloadExcel': 'Download Excel',
    'daily.downloadPdf': 'Download PDF',
    'daily.date': 'Date',
    'daily.multiDayTitle': 'The file has several days',
    'daily.multiDayMsg': 'Do you want a single report with every day, or see them separated by day?',
    'daily.combineYes': 'Single report',
    'daily.combineNo': 'Separate by day',
    'daily.fetchError': 'Error loading the daily summary.',
    'daily.exportError': 'Error downloading the daily summary Excel.',
    'daily.modeDate': 'By date (database)',
    'daily.modeFile': 'From file',
    'daily.loadFile': 'Load file',
    'daily.changeFile': 'Change file',
    'daily.pickFile': 'Load the MIA access report (MIA Access Daily Report) to see the summary. The file is not saved to the database.',
    'daily.fileEmpty': 'The file has no punch with a valid date and time.',
    'nav.timestamps': 'Punches',
    'nav.earlyAuth': 'Early arrivals',
    'nav.lateAuth': 'Authorized late arrivals',
    'nav.ptoManual': 'Manual PTO',
    'nav.holidays': 'Holidays',
    'pto.title': 'Manual PTO',
    'pto.help': 'Register PTO hours manually to complete an employee’s day (e.g. reach 40 hours) in emergencies or when waiting on a punch. Saved as an Approved PTO absence and added automatically when the week is calculated. One entry can cover several consecutive days: pick from and to, and the hours apply to every day in the range.',
    'pto.empty': 'No PTO entries found.',
    'pto.fetchError': 'Error loading PTO.',
    'pto.dateCol': 'Date',
    'pto.dateFrom': 'From',
    'pto.dateTo': 'To',
    'pto.days': 'days',
    'pto.dayShort': 'day',
    'pto.hoursCol': 'PTO hours',
    'pto.hoursPerDay': 'PTO hours per day',
    'pto.rangeHint': 'Leave "To" empty for a single day. With a range, the hours apply to EVERY day in it — weekends included if they fall inside.',
    'pto.rangeInvalid': 'The end date cannot be before the start date.',
    'pto.dateReq': 'Date is required.',
    'pto.hoursReq': 'PTO hours are required.',
    'pto.newTitle': 'New PTO',
    'pto.editTitle': 'Edit PTO',
    'pto.created': 'PTO created.',
    'pto.updated': 'PTO updated.',
    'pto.deleted': 'PTO deleted.',
    'pto.deleteConfirm': 'Delete PTO?',
    'pto.notePh': 'e.g. emergency, completed to 40',
    'nav.doors': 'Doors',
    'nav.auditLog': 'Audit Log',
    'nav.logout': 'Log Out',
    'nav.logoutConfirm': 'Are you sure you want to log out?',
    'nav.logoutYes': 'Yes, log out',
    'nav.title': 'TMS Payroll',
    'nav.sepTime': 'Time & Attendance',
    'nav.sepConfig': 'History',

    // Audit Log
    'audit.title': 'Audit Log',
    'audit.empty': 'No audit entries.',
    'audit.table': 'Table',
    'audit.user': 'User',
    'audit.action': 'Action',
    'audit.recordId': 'Record ID',
    'audit.date': 'Date',
    'audit.ip': 'IP',
    'audit.reason': 'Reason',
    'audit.searchPh': 'Search in values or reason...',
    'audit.allTables': 'All tables',
    'audit.allUsers': 'All users',
    'audit.allActions': 'All actions',
    'audit.before': 'Before',
    'audit.after': 'After',
    'audit.viewDetail': 'View detail',
    'audit.entries': 'entries',
    'audit.field': 'Field',
    'audit.oldValue': 'Old value',
    'audit.newValue': 'New value',
    'audit.noChanges': 'No changes detected.',
    'audit.detailTitle': 'Change detail',
    'audit.reasonRequired': 'Reason required',
    'audit.reasonRequiredMsg': 'Provide the reason for the change for audit purposes.',
    'audit.reasonPh': 'Why is this being modified?',

    // Dashboard
    'dash.title': 'Dashboard',
    'dash.employees': '1. Employees',
    'dash.employeesDesc': 'Register and manage employees',
    'dash.reports': '2. Reports',
    'dash.reportsDesc': 'Import file and calculate hours',
    'dash.records': '3. Records',
    'dash.recordsDesc': 'Timecard history',
    'dash.absences': '4. Absences',
    'dash.absencesDesc': 'Register absences',
    'dash.holidays': 'Holidays',
    'dash.holidaysDesc': 'Public holidays',

    // Common
    'common.save': 'Save',
    'common.saving': 'Saving...',
    'common.cancel': 'Cancel',
    'common.close': 'Close',
    'common.refresh': 'Clear filters',
    'common.edit': 'Edit',
    'common.delete': 'Delete',
    'common.search': 'Search...',
    'common.select': 'Select...',
    'common.error': 'Error',
    'common.confirm': 'Confirm',
    'common.confirmMsg': 'This action cannot be undone.',
    'common.loading': 'Loading...',
    'common.loadingData': 'Loading data...',
    'common.noData': 'No data available.',
    'common.exporting': 'Exporting...',
    'common.exported': 'Exported',
    'common.importing': 'Importing...',
    'common.importExcel': 'Import Excel',
    'common.exportExcel': 'Export Excel',
    'common.name': 'Name',
    'common.lastName': 'Last Name',
    'common.badge': 'Badge',
    'common.type': 'Type',
    'common.status': 'Status',
    'common.department': 'Department',
    'common.company': 'Company',
    'common.location': 'Location',
    'common.actions': 'Actions',
    'common.from': 'From',
    'common.to': 'To',
    'common.previous': 'Previous',
    'common.next': 'Next',
    'common.showing': 'Showing',
    'common.of': 'of',
    'common.emptyFile': 'Empty file',
    'common.emptyFileMsg': 'The file contains no data.',
    'common.fileReadError': 'Could not read the file.',
    'common.saveError': 'Error saving.',
    'common.deleteError': 'Error deleting.',
    'common.new': 'New',
    'common.newFem': 'New',
    'common.newMasc': 'New',
    'common.saved': 'Saved',
    'common.deleted': 'Deleted',
    'common.date': 'Date',
    'common.time': 'Time',
    'common.apply': 'Apply',
    'common.clear': 'Clear',
    'common.all': 'All',
    'common.active': 'Active',

    // Employees
    'emp.title': 'Employees',
    'emp.search': 'Search employee...',
    'emp.detectDups': 'Detect duplicates',
    'emp.editTitle': 'Edit Employee',
    'emp.newTitle': 'New Employee',
    'emp.nameReq': 'First Name *',
    'emp.lastNameReq': 'Last Name *',
    'emp.badgeNumber': 'Badge Number',
    'emp.shiftStart': 'Shift Start',
    'emp.shiftEnd': 'Shift End',
    'emp.schedule': 'Schedule',
    'emp.updated': 'Employee updated',
    'emp.created': 'Employee created',
    'emp.deleted': 'Employee deleted',
    'emp.empty': 'No employees found.',
    'emp.deleteConfirm': 'This employee will be permanently deleted.',
    'emp.importTitle': 'Import employees',
    'emp.importReview': 'Review data before importing. Badge, Name and Type are required.',
    'emp.typeReq': 'Type *',
    'emp.entry': 'Start',
    'emp.exit': 'End',
    'emp.incomplete': 'Incomplete data',
    'emp.incompleteMsg': 'Badge, Name, Type and Location are required for all employees.',
    'emp.imported': 'Employees imported',
    'emp.importedMsg': 'employees created successfully.',
    'emp.importError': 'Error importing employees.',
    'emp.searchingDups': 'Searching duplicates...',
    'emp.noDups': 'No duplicates',
    'emp.noDupsMsg': 'No employees with similar names found.',
    'emp.dupBadgeTitle': 'Duplicate badge',
    'emp.dupBadgeMsg': 'An employee with badge {{badge}} already exists. Please review the file and try again.',
    'emp.dupTitle': 'Duplicate employees',
    'emp.dupDesc': 'Employees with similar names but different badge. Select the badge to keep and the correct name, then merge.',
    'emp.dupResolved': 'All duplicates have been resolved.',
    'emp.badgeKeep': 'Badge to keep (User No):',
    'emp.correctName': 'Correct name:',
    'emp.keep': 'KEEP',
    'emp.remove': 'REMOVE',
    'emp.confirmMerge': 'Confirm merge',
    'emp.keepBadge': 'Keep Badge',
    'emp.removeBadge': 'Remove Badge',
    'emp.finalName': 'Final name:',
    'emp.mergeWarning': 'All timestamps, timecards and absences will be reassigned.',
    'emp.merge': 'Merge',
    'emp.merging': 'Merging...',
    'emp.merged': 'Merged',
    'emp.mergeError': 'Error merging.',
    'emp.exportSuccess': 'Employees downloaded successfully.',
    'emp.exportError': 'Could not export.',

    // Absences
    'abs.title': 'Absences',
    'abs.search': 'Search employee...',
    'abs.editTitle': 'Edit Absence',
    'abs.newTitle': 'New Absence',
    'abs.employee': 'Employee *',
    'abs.employeeSearch': 'Search by name or badge...',
    'abs.notFound': 'Employee not found',
    'abs.startDate': 'Start Date *',
    'abs.endDate': 'End Date',
    'abs.typeReq': 'Type *',
    'abs.ptoHrs': 'PTO (hrs)',
    'abs.paid': 'Paid',
    'abs.unpaid': 'Unpaid',
    'abs.updated': 'Absence updated',
    'abs.created': 'Absence registered',
    'abs.deleted': 'Absence deleted',
    'abs.empty': 'No absences found.',
    'abs.deleteConfirm': 'This absence will be permanently deleted.',
    'abs.importTitle': 'Import Absences',
    'abs.importFound': '',
    'abs.importRecords': 'records ready to import.',
    'abs.importCols': 'Please verify the data is correct before proceeding.',
    'abs.importMore': 'additional records not shown',
    'abs.importComplete': 'Import complete',
    'abs.importedMsg': 'absences imported.',
    'abs.importSkipped': 'skipped because the employee does not exist. Register these badges before importing:',
    'abs.importError': 'Error importing.',
    'abs.tabAbsences': 'Absences in system',
    'abs.tabRequests': 'Approved requests',
    'abs.pendingBubble': 'Approved requests pending to add to the system',
    'absReq.fetchError': 'Error loading approved requests.',
    'absReq.requester': 'Requester',
    'absReq.weekdays': 'Weekdays',
    'absReq.weekdaysLower': 'weekdays',
    'absReq.approvedBy': 'Approved by',
    'absReq.employee': 'Employee in system',
    'absReq.unlinked': 'Not linked',
    'absReq.inSystem': 'In system',
    'absReq.pending': 'To add',
    'absReq.apply': 'Add',
    'absReq.applied': 'Request added to the system',
    'absReq.applyTitle': 'Add request to the system',
    'absReq.day': 'day',
    'absReq.search': 'Search by name or email...',
    'absReq.allTypes': 'All types',
    'absReq.onlyPending': 'Only to add',
    'absReq.empty': 'No approved requests.',
    'absReq.managerComment': 'Manager comment',
    'absReq.byName': '(suggested by name, confirm it is the right person)',
    'absReq.changeEmployee': 'Change employee...',
    'absReq.newEmp': 'Not registered? Register',
    'absReq.newEmpTitle': 'Register new employee',
    'absReq.newEmpSave': 'Register employee',
    'absReq.newEmpMissing': 'Missing data',
    'absReq.newEmpMissingMsg': 'Badge, name, last name, location and type are required.',
    'absReq.newEmpNotPerm': 'Note: only PERM employees get paid PTO. With this type the absence is recorded but at 0 hrs.',
    'absReq.summary': '{days} weekdays will be added (Saturday and Sunday excluded) = {hrs} PTO hrs.',
    'abs.invalidEmp': 'Invalid employee',
    'abs.invalidEmpMsg': 'Enter a valid badge and wait for verification.',
    'abs.invalidDates': 'Invalid dates',
    'abs.invalidDatesMsg': 'End date cannot be before start date.',
    'abs.fileError': 'Could not read the Excel file.',
    'abs.dept': 'Dept',
    'abs.employee2': 'Employee',
    'abs.startDateCol': 'Start Date',
    'abs.endDateCol': 'End Date',

    // Reports
    'rep.title': 'Reports',
    'rep.selectFacility': 'Select Facility',
    'rep.miami': 'Miami',
    'rep.austin': 'Austin',
    'rep.importFile': 'Import File',
    'rep.clickUpload': 'Click to select file',
    'rep.changeFile': 'Change file',
    'rep.selectFirst': 'Select facility first',
    'rep.xlsFormat': '.xlsx or .xls',
    'rep.records': 'records from',
    'rep.processing': 'Processing...',
    'rep.import': 'Import',
    'rep.importRecords': 'records',
    'rep.saving': 'Saving...',
    'rep.savingMsg': 'Importing timestamps and calculating hours.',
    'rep.calculating': 'Calculating hours per employee...',
    'rep.importComplete': 'Import complete',
    'rep.noDateTitle': 'No dates',
    'rep.noDateMsg': 'No dates detected in the file.',
    'rep.processError': 'Processing error',
    'rep.unexpectedError': 'Unexpected error.',
    'rep.recalculating': 'Recalculating...',
    'rep.recalcComplete': 'Recalculation complete',
    'rep.recalcMsg': 'timecards calculated.',
    'rep.period': 'Period:',
    'rep.recalcError': 'Error recalculating.',
    'rep.typeRequired': 'Type required',
    'rep.typeRequiredMsg': 'Select the type for all doors.',
    'rep.configureDoors': 'Configure doors',
    'rep.configureDoorsDesc': 'The following doors from the file are not configured. Assign the type for each one.',
    'rep.doorName': 'Door name',
    'rep.configAndContinue': 'Configure and continue',
    'rep.configError': 'Error configuring doors.',
    'rep.fileDups': 'Possible duplicates in file',
    'rep.fileDupsDesc': 'The file contains badges with similar names. Select the badge to keep and the correct name.',
    'rep.samePerson': 'Same person',
    'rep.detectedBadges': 'Detected badges:',
    'rep.inSystem': 'IN SYSTEM',
    'rep.mergeLabel': 'MERGE',
    'rep.mergeTimestamps': 'Timestamps from the merged badge will be reassigned to the kept badge.',
    'rep.separateImport': 'Will be imported as separate employees.',
    'rep.continue': 'Continue',
    'rep.missingTitle': 'Unregistered employees',
    'rep.missingDesc': 'The following employees appear in the file but are not registered. Complete their information to continue with the import.',
    'rep.mismatchTitle': 'Badges under someone else\'s name',
    'rep.mismatchDesc': 'The badge IS set up, but the file brings it under a different name. If nothing is decided, the hours of whoever carries that badge are paid to the registered employee. The name only travels in the file, so this is the one moment it can be noticed.',
    'rep.mismatchFile': 'In the file:',
    'rep.mismatchRegistered': 'Registered as:',
    'rep.mismatchExisting': 'Already set up as:',
    'rep.mismatchRemapHint': 'This file\'s punches are reassigned to that badge, which is where their hours live. Nobody is created: this person already exists.',
    'rep.mismatchIgnore': 'Leave it (same person)',
    'rep.mismatchRegister': 'Different person: register them separately',
    'rep.mismatchRegisterHint': 'The file\'s badge is already taken by the registered employee, so this person needs a new one. THIS file\'s punches are reassigned to the new badge, so their hours land in the calculation under their own name and not the other person\'s. Punches from earlier imports stay where they are.',
    'rep.mismatchNewBadge': 'New badge *',
    'rep.newBadgeRequired': 'New badge missing',
    'rep.newBadgeRequiredMsg': 'Assign a badge to each person being registered separately.',
    'rep.sameAs': 'Same as',
    'rep.timestampsAssign': 'Timestamps from Badge',
    'rep.willAssignTo': 'will be assigned to Badge',
    'rep.sameBadgeIntro': 'This badge is already registered, with the same number, at another facility:',
    'rep.sameBadgeCopy': 'Register them at {fac} AS WELL, with the same data',
    'rep.sameBadgeMove': 'Move them from {from} to {to} (they transferred)',
    'rep.sameBadgeNew': 'It is a different person: register from scratch',
    'rep.sameBadgeCopyHint': 'They end up with one record per facility, and each one calculates and pays its own week. Name, type, department, company and shift are copied from the existing record.',
    'rep.sameBadgeMoveHint': 'Their record changes facility; it is not duplicated. Weeks already calculated at the previous facility stay as they are.',
    'rep.sameBadgeNewHint': 'A new record is created with the data you type below. Use this only if it really is another person with the same badge number.',
    'rep.saveAndContinue': 'Save and continue',
    'rep.createError': 'Error creating employees.',
    'rep.generateReports': 'Generate Reports',
    'rep.generateTimecards': 'Generate Timecards',
    'rep.generatePayrolls': 'Generate Payrolls',
    'rep.recalculate': 'Recalculate',
    'rep.needWeekFacility': 'Pick a week and a facility',
    'rep.needWeekFacilityWhy': 'Recalculation is always scoped: filter one full Monday-to-Sunday week and one facility. You will then choose which employees of that week to recalculate.',
    'rep.recalcTip': 'Recalculate this week. Period clock-ins opens first, where you pick which employees to include and decide their times and lunches.',
    'rep.selectFacilityTitle': 'Select facility',
    'rep.selectFacilityMsg': 'Select Miami or Austin before importing.',
    'rep.fileLoaded': 'File loaded',
    'rep.fileLoadedMsg': 'records ready to import.',
    'rep.fileReady': 'File ready',
    'rep.fileReadyMsg': 'records ready to import. Duplicates resolved.',
    'rep.noHours': 'No hours calculated for the period',
    'rep.checkDoors': 'Check configured doors.',
    'rep.employees': 'employees',
    'rep.exportError': 'Export error',
    'rep.exportErrorMsg': 'Could not generate the file.',
    'rep.downloadSuccess': 'downloaded successfully.',

    // Days
    'day.mon': 'Mon',
    'day.tue': 'Tue',
    'day.wed': 'Wed',
    'day.thu': 'Thu',
    'day.fri': 'Fri',
    'day.sat': 'Sat',
    'day.sun': 'Sun',

    // Hours
    'hrs.total': 'Total',
    'hrs.regular': 'Regular',
    'hrs.overtime': 'Overtime',
    'hrs.paidAbs': 'Paid Absence',
    'hrs.facility': 'Facility',
    'hrs.employee': 'Employee',

    // Records
    'rec.title': 'Hour Records',
    'gen.title': 'Generate Reports',
    'gen.pick': 'What do you want to generate',
    'gen.intro': 'Pick the document; the next window is where you set the period, the facility and who it covers. Before it downloads you will review the time each day is paid with.',
    'gen.how': 'How it works',
    'gen.step1': 'You set the scope',
    'gen.step1Desc': 'Period, facility, and whether the report covers everyone, one employee type, or a single person.',
    'gen.step2': 'You review the hours',
    'gen.step2Desc': 'Every day with punches in the period is listed so you can confirm or correct its clock-in, clock-out and lunch.',
    'gen.step3': 'It recalculates and downloads',
    'gen.step3Desc': 'The period is recalculated with what you confirmed and the file comes from that, so what downloads is what you just reviewed.',
    'rec.search': 'Search by badge or name...',
    'rec.empty': 'No timecards found.',
    'rec.datesRequired': 'Dates required',
    'rec.datesRequiredMsg': 'Select a date range to export.',
    'rec.weekRangeRequired': 'Weekly range required',
    'rec.weekRangeRequiredMsg': 'The range must cover exactly one Monday-to-Sunday week (same as Reports).',
    'rec.facilityRequired': 'Facility required',
    'rec.facilityRequiredMsg': 'Select a facility (MIA or AUSWH) before continuing.',
    'rec.tcDownloaded': 'Timecards downloaded successfully.',
    'rec.prDownloaded': 'Payroll downloaded successfully.',
    'rec.exportError': 'Could not export.',
    'rec.period': 'Period',
    'rec.door': 'Door',
    'rec.action': 'Action',
    'rec.lateDays': 'Late days',
    'rec.lateDaysTooltip': 'Days with a CHARGED late arrival (>= 60 min after shift start). Forgiven and authorized days do not count.',
    'rec.missingOutTooltip': 'Missing clock-out — calculated by law, please review',
    // Paid clock-in time (per-day tooltip)
    'rec.paidIn': 'Paid In',
    'rec.paidOut': 'Paid Out',
    'rec.firstPunch': 'Actual punch',
    'rec.punchOut': 'Actual clock-out',
    'rec.shiftStartShort': 'Shift start',
    'rec.lateBy': 'late charged',
    'rec.lunchOn': 'Lunch: 30 min deducted',
    'rec.lunchOff': 'Lunch: not deducted',
    'rec.lunchNone': 'No lunch',
    'rec.lunchForced': 'set by hand',
    'rec.noOut': 'No clock-out: paid with the "by law" hours',
    'rec.outNotStored': 'Recalculate the week to store this day\'s clock-out time.',
    'rec.inWhy.edited': 'time typed in the calculation modal',
    'rec.inWhy.auth': 'authorization applied',
    'rec.inWhy.forgiven': 'late forgiven (paid from shift start)',
    'rec.inWhy.margin': 'lateness within the 30-min margin (forgiven by the previous scheme)',
    'rec.inWhy.rounded': 'early arrival rounded to shift start (previous scheme)',
    'rec.inWhy.actualEarly': 'early arrival paid with the actual punch',
    'rec.inWhy.actualLate': 'late arrival paid with the actual punch',
    'rec.inWhy.charged': 'late charged with the actual punch',
    'rec.inWhy.exact': 'on time',
    'rec.inNotStored': 'Recalculate the week to store this day\'s clock-in time.',
    'rec.inLegend': 'Under each day\'s hours: the clock-in time it was paid with. It defaults to the actual punch time (nothing is rounded anymore). Green with a • only on days where somebody set a different time: typed in the calculation modal, or coming from an authorization. Hover for the detail.',

    // Early arrival authorizations
    'ea.title': 'Authorized early arrivals',
    'ea.help': 'When an employee is authorized to arrive early on a date, it is applied automatically when the week is calculated (no prompt). If you set an authorized time, that time is used as their clock-in; if left empty, their real punch time is kept.',
    'ea.empty': 'No authorizations found.',
    'ea.fetchError': 'Error loading authorizations.',
    'ea.dateCol': 'Date',
    'ea.timeCol': 'Authorized time',
    'ea.ptoCol': 'PTO (hrs)',
    'ea.ptoPh': 'e.g. 8',
    'ea.shiftCol': 'Shift start',
    'ea.note': 'Note',
    'ea.notePh': 'e.g. notified by chat',
    'ea.dateReq': 'Date is required.',
    'ea.newTitle': 'New authorization',
    'ea.editTitle': 'Edit authorization',
    'ea.created': 'Authorization created.',
    'ea.updated': 'Authorization updated.',
    'ea.deleted': 'Authorization deleted.',
    'ea.deleteConfirm': 'Delete authorization?',

    // Late arrival authorizations
    'la.title': 'Authorized late arrivals',
    'la.help': 'When an employee is authorized to arrive late on a date, the late alert (yellow/orange) is hidden for that day. If you set an authorized time, that time is used as their clock-in when calculating; if left empty, their real punch time is kept.',
    'la.empty': 'No authorizations found.',
    'la.fetchError': 'Error loading authorizations.',
    'la.dateCol': 'Date',
    'la.timeCol': 'Authorized time',
    'la.ptoCol': 'PTO (hrs)',
    'la.ptoPh': 'e.g. 8',
    'la.shiftCol': 'Shift start',
    'la.note': 'Note',
    'la.notePh': 'e.g. notified by chat',
    'la.dateReq': 'Date is required.',
    'la.newTitle': 'New authorization',
    'la.editTitle': 'Edit authorization',
    'la.created': 'Authorization created.',
    'la.updated': 'Authorization updated.',
    'la.deleted': 'Authorization deleted.',
    'la.deleteConfirm': 'Delete authorization?',

    // Holidays
    'hol.title': 'Holidays',
    'hol.generate': 'Generate Holidays',
    'hol.generating': 'Generating...',
    'hol.date': 'Date',
    'hol.origDate': 'Original Date',
    'hol.takenDate': 'Observed Date',
    'hol.takenDateHelp': 'Date the company counts for the calculation. If left empty, the original date is used.',
    'hol.editTitle': 'Edit Holiday',
    'hol.newTitle': 'New Holiday',
    'hol.nameReq': 'Name *',
    'hol.dateReq': 'Original Date *',
    'hol.updated': 'Holiday updated',
    'hol.created': 'Holiday created',
    'hol.deleted': 'Holiday deleted',
    'hol.empty': 'No holidays for',
    'hol.deleteConfirm': 'This holiday will be permanently deleted.',
    'hol.generated': 'holidays generated.',
    'hol.alreadyExist': 'already existed.',
    'hol.generateError': 'Error generating holidays.',

    // Doors
    'door.title': 'Doors',
    'door.desc': 'Configure building doors for correct calculation of clock-ins, clock-outs and lunch. Only doors with a type (Clock In, Clock Out, Lunch) and Active status are used for hour calculation.',
    'door.editTitle': 'Edit Door',
    'door.newTitle': 'New Door',
    'door.number': 'Number *',
    'door.nameReq': 'Name *',
    'door.noType': 'No type',
    'door.facility': 'Facility',
    'door.priority': 'Clock In Priority',
    'door.priorityHint': '0 = no priority, 1 = primary, 2 = secondary...',
    'door.updated': 'Door updated',
    'door.created': 'Door created',
    'door.deleted': 'Door deleted',
    'door.empty': 'No doors registered.',
    'door.deleteConfirm': 'This door will be permanently deleted.',
    'door.clockIn': 'Clock In',
    'door.clockOut': 'Clock Out',
    'door.lunch': 'Lunch',
    'door.clockInNoCount': 'Clock In (No Count)',
    'door.lobby': 'Lobby (Waiting Area)',

    // Punches (Timestamps)
    'ts.title': 'Punches',
    'ts.addManual': 'Add manual punch',
    'ts.secWho': 'Employee',
    'ts.changeEmp': 'Change employee',
    'ts.clearEmpFilter': 'Clear the employee filter',
    'ts.existingTitle': 'These days already have punches',
    'ts.existingHint': 'If what you want is to fix one of these, use "Correct" instead of capturing a new one: correcting an imported punch stops the file from re-inserting it. Capture one alongside and both will coexist, with the calculation keeping the earliest.',
    'ts.tagImported': 'from the file',
    'ts.tagManual': 'by hand',
    'ts.correct': 'Correct',
    'ts.correctTip': 'Edit this punch instead of capturing a new one. Your change is then protected from file re-uploads.',
    'ts.switchToEditTitle': 'Switch to correcting?',
    'ts.switchToEditMsg': 'What you have captured in this modal is discarded and the existing punch opens for editing.',
    'ts.switchToEditYes': 'Yes, correct that one',
    'ts.addTitle': 'Add manual punch',
    'ts.punch': 'Punch',
    'ts.punches': 'punches',
    'ts.punchesLabel': 'Punches to add',
    'ts.linesHint': 'You can capture several punches for the same employee at once — a whole week if needed. Each line is saved as its own punch; a new line copies the previous one so you only change what differs. A line with no time is not saved.',
    'ts.addLine': 'Add another punch',
    'ts.removeLine': 'Remove this punch',
    'ts.dupLine': 'Two punches have the same date and time.',
    'ts.dupExisting': 'That punch already exists on that day.',
    'ts.dupExistingWhy': 'There is already a punch saved at that exact time. Use "Correct" on the existing one instead of capturing another.',
    'ts.punchesSaved': 'punches saved',
    'ts.editTitle': 'Edit punch',
    'ts.searchPh': 'Name or badge',
    'ts.showDeleted': 'Show deleted',
    'ts.entries': 'entries',
    'ts.empty': 'No punches.',
    'ts.deleted': 'Deleted',
    'ts.deleteTitle': 'Delete punch?',
    'ts.reasonLabel': 'Reason',
    'ts.reasonPh': 'Why is this being deleted?',
    'ts.reasonReq': 'Reason is required.',
    'ts.reasonEditPh': 'Why is this being edited?',
    'ts.reasonCreatePh': 'Optional — e.g. employee forgot to clock in',
    'ts.badgeReq': 'Select an employee.',
    'ts.fieldsReq': 'Fill all required fields.',
    'ts.doorReq': 'Select a door.',
    'ts.doorReqWhy': 'Hours are calculated from the door, so a punch without one is ignored.',
    'ts.manual': 'Manual',
    'ts.manualTooltip': 'Captured or corrected by hand: carries a reason in the audit log and is kept when the report is re-uploaded.',
    'ts.onlyIncomplete': 'Only incomplete',
    'ts.missingOut': 'Missing clock-out for this day',
    'ts.missingIn': 'Missing clock-in for this day',
    'ts.incomplete': 'Incomplete',
    'ts.onlyLate': 'Only late',
    'ts.late': 'Late',
    'ts.lateTooltip': 'Late arrival',

    // Status options
    'status.active': 'Active',
    'status.inactive': 'Inactive',
    'status.terminated': 'Terminated',

    // Raw data table headers
    'raw.dateTime': 'Date/Time',
    'raw.userNo': 'User No.',
    'raw.userName': 'User Name',
    'raw.doorName': 'Door Name',
    'raw.message': 'Message',

    // Export filter modal
    'export.titleTimecards': 'Export Timecards',
    'export.titlePayroll': 'Export Payroll',
    'export.filterLabel': 'Filter employees',
    'export.allEmployees': 'All employees',
    'export.byType': 'By employee type',
    'export.byBadge': 'By badge number',
    'export.byEmployee': 'By employee',
    'export.badgePlaceholder': 'Enter badge number',
    'export.employeePlaceholder': 'Search by name or badge...',
    'export.reportType': 'Report type',
    'export.detailed': 'Detailed Payroll',
    'export.detailedSub': 'Day-by-day breakdown',
    'export.summary': 'Total Hours Summary',
    'export.summarySub': 'Condensed, no daily breakdown',
    'export.allEmployeesSub': 'The whole facility',
    'export.byTypeSub': 'PERM, TEMP, CONTR...',
    'export.byEmployeeSub': 'A single person',
    'export.pdfSub': 'Ready to print',
    'export.excelSub': 'Editable in a spreadsheet',
    'export.thisWeek': 'This week',
    'export.lastWeek': 'Last week',
    'export.willDownload': 'You will download',
    'export.pendingFacility': 'Facility missing',
    'export.pendingDates': 'Period missing',
    'export.pendingEmployee': 'Pick the employee',
    'export.facilityFromEmployee': 'Taken from the employee',
    'export.facilityMismatch': 'This employee belongs to another facility',
    'export.manualChecking': 'Checking manual punches...',
    'export.manualNone': 'No manually entered punches in the period',
    'export.manualFound': 'punches entered by hand in the period',
    'export.manualWhy': 'Entered by a person with a reason, not read at the door. Worth reviewing before paying.',
    'export.manualMore': 'and {n} more',
    'export.export': 'Export',
    'export.facilityLabel': 'Facility',
    'export.facilityRequired': 'Select a facility',
    'export.selectFacility': 'Select facility...',
    'export.companyLabel': 'Company',
    'export.allCompanies': 'All companies',
    'export.sectionDocument': 'Document',
    'export.sectionFilters': 'Filters',
    'export.sectionPeriod': 'Period',
    'export.periodRequired': 'Select the date range to export',
    'export.periodHint': 'The report uses these dates, not the ones in the screen filter.',
    'export.format': 'File format',
    'export.pdf': 'PDF',
    'export.excel': 'Excel',

    // Early arrivals modal
    'early.title': 'Clock-in times for the period',
    'early.description': 'Every day is paid with the REAL punch time. Nothing is rounded automatically: if a day has to be paid from another time, type it here.',
    'early.dayHint': 'Early arrivals (before the shift) and late ones (more than 30 min after it) are flagged orange, and days carrying a vacation, PTO or holiday with punches anyway are flagged purple. Any day can be edited; days with an authorized time open with that time already set.',
    'early.shiftStart': 'Shift start:',
    'early.authorized': 'Authorized',
    'early.day': 'day',
    'early.days': 'days',
    'early.employee': 'employee',
    'early.employees': 'employees',
    'early.editableDays': 'editable days',
    'early.colDate': 'Date',
    'early.colPunch': 'Actual in',
    'early.colPunchOut': 'Actual out',
    'early.colFlag': 'Flag',
    'early.colPaid': 'Paid from',
    'early.colPaidOut': 'Paid until',
    'early.colLunch': 'Lunch',
    'early.flagEarly': 'Early',
    'early.flagLate': 'Late',
    'early.flagManual': 'Hand-made punch',
    'early.flagAbsence': 'Absence',
    'early.flagHoliday': 'Holiday',
    'early.noPunch': 'no punches',
    'early.noPunchTip': 'A day of the absence with no punches: there is no clock-in to decide. Listed so you see the whole absence.',
    'early.absDay': 'day with vacation/absence',
    'early.absDays': 'days with vacation/absence',
    'early.absTip': 'This day has an approved absence and punches anyway. It pays no PTO hours (the employee is not PERM, or the absence carries no hours), so it is calculated from its punches like any other day.',
    'early.absPaysTip': 'This day has an approved absence and punches anyway. The day pays what was worked PLUS the absence hours:',
    'early.holPaysTip': 'Holiday with no punches: it pays the employee\'s full shift, clock-in to clock-out. Holidays take no lunch deduction.',
    'early.unregistered': 'Does not exist',
    'early.unregisteredTip': 'This badge has punches but is NOT set up in Employees for this facility. The calculation pays it hours anyway, so either register it or find out whose badge it is.',
    'early.unregWarnOne': 'badge clocked in over this period and is not set up in Employees.',
    'early.unregWarnMany': 'badges clocked in over this period and are not set up in Employees.',
    'early.unregWarnDesc': 'The calculation pays them hours all the same. Register them right here with the Register button, or find out whose badges those are.',
    'early.register': 'Register',
    'early.registerTip': 'Set this badge up in Employees without leaving the calculation.',
    'early.registerSave': 'Create employee',
    'early.registered': 'Registered',
    'early.registeredTip': 'This badge was just set up in Employees.',
    'early.regNameReq': 'Name and last name are required.',
    'early.regTypeReq': 'Type is required.',
    'early.regError': 'The employee could not be created.',
    'early.inactive': 'Inactive',
    'early.inactiveTip': 'This badge is set up in Employees but with a status other than Active, and it clocked in over this period anyway. The calculation pays it hours all the same: check whether the termination is right, or whose badge it is.',
    'early.holWorkedTip': 'Holiday that does have punches: the day pays what was worked — the holiday adds no hours on top.',
    'early.ptoIgnored': 'worked + PTO',
    'early.ptoIgnoredTip': 'Day with approved vacation/PTO and punches: the day pays what was worked (minus lunch, if the checkbox is on) PLUS the absence hours. The In and Out are not edited here, but its lunch is.',
    'early.punchTip': 'The time the employee actually clocked in.',
    'early.paidTip': 'The time this day will be paid from. Defaults to the actual punch.',
    'early.punchOutTip': 'The time the employee actually clocked out.',
    'early.paidOutTip': 'The time this day will be paid until. Defaults to the exit punch. If the day has no clock-out, type it here and the day is calculated normally (out - in - lunch).',
    'early.lunchTip': 'Whether the 30-min lunch comes off this day. Checked by default on every normal workday, no matter how many hours it is. Uncheck it if the employee did not take lunch that day.',
    'early.lunchForced': 'Lunch forced',
    'early.lunchForcedTip': 'This day does not follow the default: somebody decided its lunch by hand.',
    'early.shortDay': 'Pays only',
    'early.shortDayAsk': 'lunch?',
    'early.shortDayTip': 'This Austin day pays less than the facility\'s "by law" hours (5 h) and still has the 30-min lunch deducted. Austin has no lunch door, so the punches cannot say whether the employee ate: if they did not, uncheck the Lunch box and the day gets the half hour back.',
    'early.noOut': 'No clock-out',
    'early.noOutTip': 'This day has a clock-in but no exit punch at all. As it stands it is paid with the provisional "by law" hours (MIA 6:30, AUSWH 4:30). Type the clock-out to have it calculated normally.',
    'early.badSpan': 'Out before In',
    'early.badSpanTip': 'The clock-out ({out}) is at or before the clock-in ({in}). This is almost always an AM that should have been PM: the day drops to 0 hours and comes out blank on the exported timecard. Fix the time before calculating.',
    'early.badSpanDay': 'day with a bad time',
    'early.badSpanDays': 'days with a bad time',
    'early.badSpanCardTip': 'This employee has days whose clock-out is before the clock-in. Check the AM/PM on the times in red.',
    'early.badSpanWarnOne': 'day with the clock-out before the clock-in',
    'early.badSpanWarnMany': 'days with the clock-out before the clock-in',
    'early.badSpanWarnDesc': 'Check the AM/PM: a 3 in the afternoon typed as 3:00 AM lands before the clock-in. The calculation does not handle shifts crossing midnight, so those days would pay 0 hours and show up empty on the exported report. Calculating is blocked until they are fixed.',
    'early.badSpanMore': 'and {n} more',
    'early.badSpanBlocked': 'Fix the times in red to continue.',
    'early.resetTip': 'Back to the actual punch times.',
    'early.allPunch': 'All actual times',
    'early.allShift': 'All from shift start',
    'early.alertDay': 'flagged day',
    'early.alertDays': 'flagged days',
    'early.editedDay': 'edited day',
    'early.editedDays': 'edited days',
    'early.editedSummary': 'days will be paid from a time other than the punch',
    'early.includeTip': 'Include this employee in the calculation. Unchecked, their week is left exactly as it is: it keeps the times and lunches decided before.',
    'early.excludedSummary': 'employees left out',
    'early.noneSelected': 'Check at least one employee to calculate.',
    'early.defaultSummary': 'days will be paid with the actual punch time',
    'early.continue': 'Continue to calculation',
    'early.scanning': 'Scanning clock-in times...',

    // Merge result
    'emp.mergeResult': 'Timestamps: {{timestamps}}, Timecards: {{timecards}}, Absences: {{absences}}',
  },
};

export default translations;
